import React from "react";
import Image from "next/image";
import {AccreditationSmallSection} from "@/.storyblok/types/319751/storyblok-components";
import { SbBlokData, storyblokEditable } from "@storyblok/react";

interface TrustSmallProps {
    blok?: AccreditationSmallSection & SbBlokData;
    title?: string;
}

const TrustSmall: React.FC<TrustSmallProps> = ({
  blok,
  title,
}) => {
    const accreditations = blok?.accreditations || [];

    return (
        <div {...(blok && storyblokEditable(blok))} className="component-trust-small container position-relative">
            <div className="card card-lighter p-3">
                <h2 className="small text-center text-primary text-uppercase h-ruled max-width mb-3">
                    {title || "Trusted cyber security & compliance services"}
                </h2>
                <div className="row align-items-center justify-content-center g-2 g-sm-3">
                    {accreditations.map((item) => (
                        <div className="col-auto" key={item._uid}>
                            <Image
                                src={item.image?.filename || ""}
                                width={Number(item.width) || 46}
                                height={Number(item.height) || 46}
                                alt={item.alt_image || "Accreditation logo"}
                                title={item.alt_image || "Accreditation logo"}
                                loading={"eager"}
                                quality={75}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default TrustSmall;